/**
 * Main video of a post (views/home/art-live.php, inc/post-video.php): the
 * post's photo with a play button; clicking it puts the player in the same
 * box — a <video> for a file, YouTube's no-cookie / Vimeo's player for a
 * link. Until then the page loads nothing of the video. Without JS the link
 * opens the video on its own.
 */
const EMBED = /^https:\/\/(www\.youtube-nocookie\.com\/embed\/|player\.vimeo\.com\/video\/)/;

function player(box) {
  const title = box.dataset.videoTitle || 'Wideo';

  if (box.dataset.videoFile) {
    const src = new URL(box.dataset.videoFile, location.href);
    if (src.protocol !== 'https:' && src.protocol !== 'http:') return null;
    const video = document.createElement('video');
    video.className = 'hp-artl__video';
    video.controls = true;
    video.playsInline = true;
    video.autoplay = true; // the click is the reader's go-ahead
    video.setAttribute('aria-label', title);
    const source = document.createElement('source');
    source.src = src.href;
    if (box.dataset.videoMime) source.type = box.dataset.videoMime;
    video.append(source);
    return video;
  }

  // Only the two players the theme builds the address for.
  const src = box.dataset.videoEmbed || '';
  if (!EMBED.test(src)) return null;
  const frame = document.createElement('iframe');
  frame.className = 'hp-artl__frame';
  frame.src = src;
  frame.title = title;
  frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen';
  frame.allowFullscreen = true;
  frame.referrerPolicy = 'strict-origin-when-cross-origin';
  return frame;
}

export function initVideoEmbeds() {
  document.addEventListener('click', (event) => {
    const play = event.target.closest('.hp-artl__play');
    const box = play?.closest('[data-video-embed], [data-video-file]');
    if (!box || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const el = player(box);
    if (!el) return; // unknown address: the plain link opens it
    event.preventDefault();
    box.replaceChildren(el);
    el.focus();
  });
}
